export class DynamicFormAnswer {
  AnswerId: number;
  PortalId: number;
  QuestionId: number;
  Value: string;
  ValueString: string;
  ValueInt: number;
  ValueFloat: number;
  ValueDecimal: number;
  ValueDatetime: string;
  DalueDate: string;
  ValueTime: string;
  BitABit: boolean;
  UserID: number;
  VisibleAnswerReport: boolean;
  Created: string;
  CreatedBy: string;
  LastUpdate: Date;
  LastUpdateBy: string;
  Deleted: boolean;
  ExternalId: string;
  DynamicFormId: number;
  AnswerGroup: number;
  DynamicForms_Code: string;
  KeyName: string;
}
